import { ViewModel, View, ObservableArray } from "binder"
import { ToolManipulationView } from "./toolManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ToolTypeSelectorViewModel } from "../toolModelManipulation/toolTypeSelector-viewModel";
import { ToolStatusSelectorViewModel } from "../usageAmountManipulation/selectors/toolStatusSelector-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ITool } from "./ITool";
import { ToolModelsForToolTypeSelector } from "./toolModelsForToolTypeSelector";
import { ToolModelFromProducerSelectorViewModel } from "../usageAmountManipulation/selectors/toolModelFromProducerSelector-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";

export class ToolManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return "تعریف ابزار";
    }
    GetDefaultView(): View<ViewModel> {
        return new ToolManipulationView();
    }
    public getTypeId(): string {
        return "VM-0CC59064-AE42-4912-A0BB-4D0234FE5194"
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.isLoading = false;
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);
        this.tools = ObservableArray.create<Tool>();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;
    public set tools(v: ObservableArray<Tool>) { this._tools = v; } public get tools(): ObservableArray<Tool> { return this._tools; } private _tools: ObservableArray<Tool>;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ToolPlaceHolderServices/GetAllSingleTools', {
                FilteringInformation: filteringInformation
            });
            this.tools.update(...result.SingleTools.map((item, index) => {
                let tool: Tool = new Tool(this);
                tool.index = index + 1;
                tool.singleToolId = item.SingleToolId;
                tool.serial = item.SerialId;
                tool.setToolModelId(item.SingleToolModelId);
                tool.toolModelName = item.SingleToolModelName;
                tool.setToolTypeId(item.SingleToolTypeId);
                tool.toolTypeName = item.SingleToolTypeName;
                tool.setToolValidStatusId(item.SingleToolValidStatusId);
                tool.toolValidStatusName = item.SingleToolValidStatusName;
                tool.setToolModelFromProducerId(item.SingleToolProducerId);
                tool.toolModelFromProducerName = item.SingleToolProducerName;
                return tool;
            }))
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async createNewTool(): Promise<void> {
        let popup = new ToolEditor(this, new InsertServerUpdater());
        let result = await this.showPopup(popup);
        if (result == true) {
            this.refresh();
        }
    }

    async updateTool(tool: ITool): Promise<void> {
        let popup = new ToolEditor(this, new UpdateServerUpdater(), false);
        await tool.cloneTo(popup);
        let result = await this.showPopup(popup);
        if (result == true) {
            this.refresh();
        }
    }

    async removeTool(tool: ITool): Promise<void> {
        let confirm = await this.messageBoxDangerYesNo('آیا از حذف اطمینان دارید؟', 'حذف');
        if (confirm == 'no') {
            return;
        }
        let serverUpdater = new DeleteServerUpdater();
        await serverUpdater.execute(tool);
        if (serverUpdater.isSuccessful == true) {
            await this.messageBoxConfirmSuccess(serverUpdater.message, "عملیات موفق");
            this.refresh();
        } else if (serverUpdater.isSuccessful == false) {
            await this.messageBoxConfirmWarning(serverUpdater.message, "خطا در عملیات");
        }
    }
}

export class Tool extends ViewModel implements ITool {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ToolManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.serials = ObservableArray.create<string>();
    }

    private _typedParent: ToolManipulationViewModel;
    public set index(v: int) { this._index = v; } public get index(): int { return this._index; } private _index: int;
    public set singleToolId(v: string) { this._singleToolId = v; } public get singleToolId(): string { return this._singleToolId; } private _singleToolId: string;
    public set toolTypeId(v: string) { this._toolTypeId = v; } public get toolTypeId(): string { return this._toolTypeId; } private _toolTypeId: string;
    public set toolTypeName(v: string) { this._toolTypeName = v; } public get toolTypeName(): string { return this._toolTypeName; } private _toolTypeName: string;
    public set toolModelId(v: string) { this._toolModelId = v; } public get toolModelId(): string { return this._toolModelId; } private _toolModelId: string;
    public set toolModelName(v: string) { this._toolModelName = v; } public get toolModelName(): string { return this._toolModelName; } private _toolModelName: string;
    public set toolModelFromProducerId(v: string) { this._toolModelFromProducerId = v; } public get toolModelFromProducerId(): string { return this._toolModelFromProducerId; } private _toolModelFromProducerId: string;
    public set toolModelFromProducerName(v: string) { this._toolModelFromProducerName = v; } public get toolModelFromProducerName(): string { return this._toolModelFromProducerName; } private _toolModelFromProducerName: string;
    public set toolValidStatusId(v: string) { this._toolValidStatusId = v; } public get toolValidStatusId(): string { return this._toolValidStatusId; } private _toolValidStatusId: string;
    public set toolValidStatusName(v: string) { this._toolValidStatusName = v; } public get toolValidStatusName(): string { return this._toolValidStatusName; } private _toolValidStatusName: string;
    public set serial(v: string) { this._serial = v; } public get serial(): string { return this._serial; } private _serial: string;
    public set serials(v: ObservableArray<string>) { this._serials = v; } public get serials(): ObservableArray<string> { return this._serials; } private _serials: ObservableArray<string>;

    edit(): void {
        this._typedParent.updateTool(this);
    }

    remove(): void {
        this._typedParent.removeTool(this);
    }

    requetLoadCombos() {
        throw new Error("Method not implemented.");
    }

    async cloneTo(tool: ITool) {
        tool.singleToolId = this.singleToolId;
        tool.serial = this.serial;
        tool.setToolTypeId(this.getToolTypeId());
        tool.setToolModelId(this.getToolModelId());
        tool.setToolModelFromProducerId(this.getToolModelFromProducerId());
        tool.setToolValidStatusId(this.getToolValidStatusId());
        tool.setSerials(this.getSerials());
    }

    setToolTypeId(id: string) {
        this.toolTypeId = id;
    }
    getToolTypeId() {
        return this.toolTypeId;
    }
    setToolModelId(id: string) {
        this.toolModelId = id;
    }
    getToolModelId(): string {
        return this.toolModelId;
    }
    setToolModelFromProducerId(id: string) {
        this.toolModelFromProducerId = id;
    }
    getToolModelFromProducerId(): string {
        return this.toolModelFromProducerId;
    }
    setToolValidStatusId(id: string) {
        this.toolValidStatusId = id;
    }
    getToolValidStatusId() {
        return this.toolValidStatusId;
    }
    setSerials(serials: string[]) {
        this.serials.update(...serials.map(serial => serial));
    }
    getSerials() {
        return this.serials;
    }
}

export class ToolEditor extends ViewModel implements IPopup, ITool {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ToolManipulationViewModel, serverUpdater: IServerUpdater, isEditable: boolean = true) {
        super(parent);
        this.serials = ObservableArray.create<Serial>();
        this._serverUpdater = serverUpdater;
        this.isEditable = isEditable;

        this.toolModelSelector = new ToolModelsForToolTypeSelector(this);
        this.toolValidStatusSelector = new ToolStatusSelectorViewModel(this);
        this.toolModelFromProducerSelector = new ToolModelFromProducerSelectorViewModel(this);

        this.toolTypeSelector = new ToolTypeSelectorViewModel(this);
        this.toolTypeSelector.refresh();
        this.toolTypeSelector.onSelectionChanged = selectedItem => {
            this.toolModelSelector = new ToolModelsForToolTypeSelector(this, selectedItem.id);
            this.toolModelSelector.refresh();
            this.toolModelSelector.onSelectionChanged = item => {
                this.toolValidStatusSelector = new ToolStatusSelectorViewModel(this, item.id);
                this.toolValidStatusSelector.refresh();
                this.toolModelFromProducerSelector = new ToolModelFromProducerSelectorViewModel(this, item.id);
                this.toolModelFromProducerSelector.refresh();
            }
        };
    }

    private _serverUpdater: IServerUpdater;
    public set singleToolId(v: string) { this._singleToolId = v; } public get singleToolId(): string { return this._singleToolId; } private _singleToolId: string;
    public set toolTypeSelector(v: ToolTypeSelectorViewModel) { this._toolTypeSelector = v; } public get toolTypeSelector(): ToolTypeSelectorViewModel { return this._toolTypeSelector; } private _toolTypeSelector: ToolTypeSelectorViewModel;
    public set toolModelSelector(v: ToolModelsForToolTypeSelector) { this._toolModelSelector = v; } public get toolModelSelector(): ToolModelsForToolTypeSelector { return this._toolModelSelector; } private _toolModelSelector: ToolModelsForToolTypeSelector;
    public set toolValidStatusSelector(v: ToolStatusSelectorViewModel) { this._toolValidStatusSelector = v; } public get toolValidStatusSelector(): ToolStatusSelectorViewModel { return this._toolValidStatusSelector; } private _toolValidStatusSelector: ToolStatusSelectorViewModel;
    public set toolModelFromProducerSelector(v: ToolModelFromProducerSelectorViewModel) { this._toolModelFromProducerSelector = v; } public get toolModelFromProducerSelector(): ToolModelFromProducerSelectorViewModel { return this._toolModelFromProducerSelector; } private _toolModelFromProducerSelector: ToolModelFromProducerSelectorViewModel;
    public set serial(v: string) { this._serial = v; } public get serial(): string { return this._serial; } private _serial: string;
    public set serials(v: ObservableArray<Serial>) { this._serials = v; } public get serials(): ObservableArray<Serial> { return this._serials; } private _serials: ObservableArray<Serial>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set isEditable(v: boolean) { this._isEditable = v; } public get isEditable(): boolean { return this._isEditable; } private _isEditable: boolean;
    public set toolTypeId(v: string) { this._toolTypeId = v; } public get toolTypeId(): string { return this._toolTypeId; } private _toolTypeId: string;
    public set toolModelId(v: string) { this._toolModelId = v; } public get toolModelId(): string { return this._toolModelId; } private _toolModelId: string;
    public set toolModelFromProducerId(v: string) { this._toolModelFromProducerId = v; } public get toolModelFromProducerId(): string { return this._toolModelFromProducerId; } private _toolModelFromProducerId: string;
    public set toolValidStatusId(v: string) { this._toolValidStatusId = v; } public get toolValidStatusId(): string { return this._toolValidStatusId; } private _toolValidStatusId: string;

    setToolTypeId(id: string) {
        this.toolTypeId = id;
    }
    getToolTypeId() {
        return this.toolTypeSelector.selectedItem?.id;
    }
    setToolModelId(id: string) {
        this.toolModelId = id;
    }
    getToolModelId(): string {
        return this.toolModelSelector.selectedItem?.id;
    }
    setToolModelFromProducerId(id: string) {
        this.toolModelFromProducerId = id;
    }
    getToolModelFromProducerId(): string {
        return this.toolModelFromProducerSelector.selectedItem?.id;
    }
    setToolValidStatusId(id: string) {
        this.toolValidStatusId = id;
    }
    getToolValidStatusId() {
        return this.toolValidStatusSelector.selectedItem?.id;
    }
    setSerials(serials: string[]) {
        this.serials.update(...serials.map(s => {
            let serial = new Serial(this);
            serial.serial = s;
            return serial;
        }))
    }
    getSerials() {
        return this.serials.map(s => s.serial);
    }
    async requetLoadCombos(): Promise<void> {
        setTimeout(this.loadCombos, 1000);
    }
    async loadCombos() {
        this.toolTypeSelector.selectById(this.toolTypeId);
        this.toolModelSelector.selectById(this.toolModelId);
        this.toolValidStatusSelector.selectById(this.toolValidStatusId);
        this.toolModelFromProducerSelector.selectById(this.toolModelFromProducerId);
    }

    addNewSerial(): void {
        let newSerial = new Serial(this);
        newSerial.serial = this.serial;
        if (stringIsNullOrEmpty(newSerial.serial)) {
            this.messageBoxConfirmWarning('سریال ابزار مشخص نشده است.', 'خطا در افزودن');
        }
        else {
            this.serials.push(newSerial);
            this.serial = null;
        }
    }

    removeSerial(s: Serial): void {
        this.serials.remove(s);
    }

    closePopup(result: boolean = false) {

    }

    back() {
        this.closePopup();
    }

    async cloneTo(tool: ITool) {
        tool.singleToolId = this.singleToolId;
        tool.serial = this.serial;
        tool.setToolTypeId(this.getToolTypeId());
        tool.setToolModelId(this.getToolModelId());
        tool.setToolModelFromProducerId(this.getToolModelFromProducerId());
        tool.setToolValidStatusId(this.getToolValidStatusId());
        tool.setSerials(this.getSerials());
    }

    async confirm() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت ابزار');
            return;
        } else {
            try {
                this.isLoading = true;
                await this._serverUpdater.execute(this);
                if (this._serverUpdater.isSuccessful == true) {
                    await this.messageBoxConfirmSuccess(this._serverUpdater.message, "عملیات موفق");
                    this.closePopup(true);
                } else if (this._serverUpdater.isSuccessful == false) {
                    await this.messageBoxConfirmWarning(this._serverUpdater.message, "خطا در عملیات");
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت ابزار', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.getToolTypeId())) {
            result.push('نوع ابزار مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.getToolModelId())) {
            result.push('مدل ابزار مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.getToolValidStatusId())) {
            result.push('وضعیت ابزار مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.getToolModelFromProducerId())) {
            result.push('سازنده مشخص نشده است.');
        }
        if (this.isEditable == true) {
            if (this.serials.length == 0) {
                result.push('سریال ابزار مشخص نشده است.');
            }
        }
        else {
            if (stringIsNullOrEmpty(this.serial)) {
                result.push('سریال ابزار مشخص نشده است.');
            }
        }
        this.loadCombos();
        return result;
    }
}

export class Serial extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ToolEditor) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: ToolEditor;
    public set serial(v: string) { this._serial = v; } public get serial(): string { return this._serial; } private _serial: string;

    remove(): void {
        this._typedParent.removeSerial(this);
    }
}

interface IServerUpdater {
    set message(value: string); get message(): string;
    set isSuccessful(value: boolean); get isSuccessful(): boolean;
    execute(tool: ITool): Promise<void>;
}

class InsertServerUpdater implements IServerUpdater {
    private set message(v: string) { this._message = v; } public get message(): string { return this._message; } private _message: string;
    private set isSuccessful(v: boolean) { this._isSuccessful = v; } public get isSuccessful(): boolean { return this._isSuccessful; } private _isSuccessful: boolean;

    async execute(tool: ITool): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/ToolPlaceHolderServices/CreateSingleTool', {
            ToolValidStatusId: tool.getToolValidStatusId(),
            ToolModelFromProducerId: tool.getToolModelFromProducerId(),
            SerialIds: tool.getSerials()
        });
        if (result.IsSuccessful == true) {
            this.isSuccessful = true;
            this.message = "ابزار با موفقیت ثبت شد.";
        } else {
            this.isSuccessful = false;
            this.message = "ثبت ابزار با مشکل مواجه شد."
        }
    }
}

class UpdateServerUpdater implements IServerUpdater {
    private set message(v: string) { this._message = v; } public get message(): string { return this._message; } private _message: string;
    private set isSuccessful(v: boolean) { this._isSuccessful = v; } public get isSuccessful(): boolean { return this._isSuccessful; } private _isSuccessful: boolean;

    async execute(tool: ITool): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/ToolPlaceHolderServices/UpdateSingleTool', {
            SingleToolId: tool.singleToolId,
            SerialId: tool.serial
        });
        if (result.IsSuccessful == true) {
            this.isSuccessful = true;
            this.message = "ابزار با موفقیت ویرایش شد.";
        } else {
            this.isSuccessful = false;
            this.message = "ویرایش ابزار با مشکل مواجه شد."
        }
    }
}

class DeleteServerUpdater implements IServerUpdater {
    private set message(v: string) { this._message = v; } public get message(): string { return this._message; } private _message: string;
    private set isSuccessful(v: boolean) { this._isSuccessful = v; } public get isSuccessful(): boolean { return this._isSuccessful; } private _isSuccessful: boolean;

    async execute(tool: ITool): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/ToolPlaceHolderServices/DeleteSingleTool', {
            SingleToolId: tool.singleToolId
        });
        if (result.IsSuccessful == true) {
            this.isSuccessful = true;
            this.message = "حذف ابزار با موفقیت انجام شد.";
        } else {
            this.isSuccessful = false;
            this.message = "حذف ابزار با مشکل مواجه شد."
        }
    }
}
